module.exports = __webpack_public_path__ + "static/notifications-29394102fa47858edbee7e0d38d2353a.png";